import axios from 'axios'

import { setupPublicInterceptors, setupPrivateInterceptors } from './setupInterceptors'

const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/optimo/api/v1'
const timeoutMs = Number(import.meta.env.VITE_API_TIMEOUT_MS || '') || 30000

const baseConfig = {
    headers: {
        'Content-Type': 'application/json',
    },
    baseURL: apiUrl,
    withCredentials: false, // TODO: Enable when CORS wildcard is removed from backend
    timeout: timeoutMs,
}

export const optimoPublicApi = axios.create(baseConfig)

export const optimoPrivateApi = axios.create(baseConfig)

export const optimoPrivateApiFormData = axios.create({
    baseURL: apiUrl,
    withCredentials: false, // TODO: Enable when CORS wildcard is removed from backend
    timeout: 120000, // 2 minutes for file uploads
})

setupPublicInterceptors(optimoPublicApi)
setupPrivateInterceptors(optimoPrivateApi)
setupPrivateInterceptors(optimoPrivateApiFormData)
